import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader';
import { CommonModule } from '@node_modules/@angular/common';
@Component({
    selector: 'angular-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class LoaderComponent implements OnInit {
    show = false;
    showHeader = false;
    private subscription: Subscription;
    private headerSubscription: Subscription;
    @Input() showLoader: boolean = false;
    constructor(
        private loaderService: LoaderService,
        private cd: ChangeDetectorRef
    ) { }
    ngOnInit() {
        if (this.showLoader) {
            this.show = this.showLoader;
        }
        else {
            this.subscription = this.loaderService.loaderState
                .subscribe((state: LoaderState) => {
                    this.show = state.show;
                    this.cd.detectChanges(); // ✅ force re-check safely
                });

            this.headerSubscription = this.loaderService.loaderHeaderState.subscribe((state: LoaderState) => {
                this.showHeader = state.show;
                this.cd.detectChanges(); // ✅ force re-check safely
            });
        }


    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
        this.headerSubscription?.unsubscribe();
    }
}
